<template>
  <OrderRequestView :table="table" :check-user="false" />
</template>

<script>
import OrderRequestView from '../../order-request/OrderRequestView';

export default {
  name: 'AdminOrderRequestView',
  components: { OrderRequestView },
  props: {
    table: String,
  },
};
</script>

<style scoped></style>
